import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment";

function getRangeDate(start, end) {
    if (!start || !end) return ''
    const startDate = moment(start);
    const endDate = moment(end);
    const duration = moment.duration(startDate.diff(endDate));
    return duration.asSeconds();
}


export default {
    name: 'tests-header',
    props: ['hasTimer'],

    data() {
        return {
            countdownTime: '00 : 00',
            time: '',
            errorClass: false
        }
    },
    watch: {
        currentTest: {
            deep: true,
            handler() {
                this.resetTime()
                this.setDate()
            }
        },
        header: {
            deep: true,
            handler() {
                this.resetTime()
                this.setDate()
            }
        }
    },
    computed: {
        ...mapGetters({
            header: 'tests/header',
            serverTime: 'setting/serverTime',
            currentTest: 'tests/currentTest',
        }),
        calculationTimeModule() {
            if (!this.currentTest) return '00 : 00'
            if (!this.currentTest.currentQuestion.data.hasOwnProperty('responseTime')) return '00 : 00'
            const duration = this.currentTest.currentQuestion.data.responseTime;
            const minutes = Math.floor(duration / 60);
            const seconds = duration % 60;
            return `${minutes > 9 ? minutes : '0' + minutes} : ${seconds > 9 ? seconds : '0' + seconds}`
        },
        startedQuestionDate() {
            if (!this.currentTest) return ''
            return this.currentTest.currentUserQuestion.data.startedAt
        },
        endedQuestionDate() {
            if (!this.currentTest) return ''
            return moment(this.startedQuestionDate)
                .add(this.currentTest.currentQuestion.data.responseTime, 'seconds')
                .format('YYYY-MM-DD HH:mm:ss')
        }
    },
    mounted() {
        this.setDate()
    },
    methods: {
        ...mapActions({
            fetchServerTime: 'setting/GET_SERVER_TIME',
        }),
        ...mapMutations({
            changeHeader: 'tests/CHANGE_HEADER',
            changeShowPopup: 'tests/CHANGE_POPUP_CANCEL_TEST',
        }),
        setDate() {
            this.fetchServerTime().then(() => {
                clearInterval(this.time)
                this.errorClass = false
                const progressTimeQuestion = getRangeDate(this.serverTime, this.startedQuestionDate)
                this.timer(progressTimeQuestion);
            })
        },
        resetTime() {
            this.countdownTime = '00 : 00';
            clearInterval(this.time)
            this.errorClass = false
        },
        closeTest() {
            if (this.$route.path.includes('/questions')) {
                this.changeShowPopup(true)
            } else {
                if (this.header.parentRoute) {
                    try {
                        this.$router.push({name: this.header.parentRoute})
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    this.$router.go(-1);
                }
                this.changeHeader({
                    show: false,
                    parentRoute: ''
                });
                clearInterval(this.time)
            }
        },
        timer(duration = 0) {
            if (!duration) return
            let time = duration;
            this.time = setInterval(() => {
                time++;
                if (this.currentTest.currentQuestion.data.responseTime < time) {
                    this.errorClass = true;
                    const currentTime = this.currentTest.currentQuestion.data.responseTime
                    const minutes = Math.floor(currentTime / 60);
                    const seconds = currentTime % 60;
                    this.countdownTime = `${minutes > 9 ? minutes : '0' + minutes} : ${seconds > 9 ? seconds : '0' + seconds}`;
                } else {
                    const minutes = Math.floor(time / 60);
                    const seconds = time % 60;
                    this.countdownTime = `${minutes > 9 ? minutes : '0' + minutes} : ${seconds > 9 ? seconds : '0' + seconds}`;
                }
            }, 1000);
        },
    },
    destroyed() {
        clearInterval(this.time);
        this.changeHeader({
            show: false
        });
    }
}
